import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getJax } from "../../../../state/selectors/JaxCkbComponent.selectors";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";
import isPortal from "../../../../common/helpers/isPortal";

const JAXCKBGeneCard = ({ card, ckbData }) => {
  const isClinical = isPortal();
  const isDisabled = !Object.keys(ckbData || {}).length;
  const disabledCardMessage = !isClinical
    ? "Only available for VarSome Clinical users"
    : undefined;
  const color = () => {
    // eslint-disable-next-line no-nested-ternary
    return Object.keys(ckbData || {}).length &&
      ckbData?.gene_role?.description.includes("oncogene")
      ? getPathogenicityColorByAllNames("Pathogenic")
      : "unset";
  };
  return (
    <CardWrapper
      {...card}
      isDisabled={isDisabled}
      color={color()}
      disabledCardMessage={disabledCardMessage}
    >
      {Object.keys(ckbData || {}).length && ckbData?.gene_role?.description ? (
        <div>
          {`Role: `}
          <span
            className="tw-font-bold"
            data-testid="gene-jax-ckb-role"
            style={{ color: color() }}
          >
            {ckbData?.gene_role?.description}
          </span>
        </div>
      ) : null}
    </CardWrapper>
  );
};

JAXCKBGeneCard.propTypes = {
  ckbData: PropTypes.shape({
    version: PropTypes.string,
    gene_descriptions: PropTypes.arrayOf(
      PropTypes.shape({
        description: PropTypes.string,
        pub_med_references: PropTypes.arrayOf(PropTypes.number),
      })
    ),
    gene_role: PropTypes.shape({
      description: PropTypes.string,
      pub_med_references: PropTypes.arrayOf(PropTypes.number),
    }),
  }),
  card: PropTypes.instanceOf(Card).isRequired,
};

JAXCKBGeneCard.defaultProps = {
  ckbData: {},
};

const mapStateToProps = (state) => ({
  ckbData: getJax(state, true),
});

export default connect(mapStateToProps)(JAXCKBGeneCard);
